import React, { useEffect, useState } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import RadioButtonUncheckedOutlinedIcon from '@material-ui/icons/RadioButtonUncheckedOutlined';
import SvgIcon from '@material-ui/core/SvgIcon';
import { makeStyles } from "@material-ui/core/styles";
import { Row, Col, Container } from 'react-bootstrap';
import { configureStatusObject } from './status';
import Ticket from './TicketTab';
import './CaseDetailsTool.scss';
import Button from '@material-ui/core/Button';
import { format, zonedTimeToUtc } from 'date-fns-tz';
import RequirementTable from './RequirementTable';
import WarningGroup from '../../../icons/Warning-group.svg';
import MenuIcon from '../../../icons/menu.svg';
import LoadingWaiting from '../../../icons/Loading-Waiting.svg';
import ArrowDropDownIcon from '../../../icons/arrow-drop-down.svg';
import NoteIcon from '../../../icons/Pen, Edit.7.svg';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import constants from '../../../constants';
import Note from './Note';
import { CircularProgress, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { httpRequest } from '../../../httpRequest';
import { ConvertUTCToLocalDateTime, ConvertUTCToLocalDate } from '../../Helpers/Formatters/UTCToLocalDate';
import accessPermission from '../../Helpers/AccessPermission';
import { SelectInput } from '../../Helpers/Inputs';
import DataTable from 'react-data-table-component';
import { arrayBufferFromBase64, openFile } from './caseFiles';
import UploadFileModal from '../../Common/UploadFileModal';
import AdditionalTicketInfo from './AdditionalTicketInfo';
import { useHistory } from "react-router-dom";
import {SESSION_STORAGE_CREATE_CASE,ILLUSTRATION_PREFILL_DATA, setSessionStorageItem, SELECTED_PRODUCT_FOR_SUBMIT_A_CASE, SESSION_STORAGE_CASE_RETURN_PATH} from '../../../sessionStorage';

const useStyles = makeStyles(theme => ({
  toolHeader: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    padding: '20px',
  },
  active: {
    borderBottom: `2px solid ${theme.palette.primary.main}`
  },
  MuiAccordionroot: {
    "&.MuiAccordion-root:before": {
      backgroundColor: "#f7f7f7 "
    }
  },
  colorPrimary: {
    color: theme.palette.primary.main
  },
  pointer: {
    cursor: "pointer"
  },
}));

export default function CaseDetailTool(props) {

  const { status, nextStep, statusDetail, callGetCaseDetails, statuses, caseImages, requestDetails, caseSummaryHistories, selectedCaseDetails, typeId, permission, isIllustration, referenceID, morganStanleyQuoteIllustrationRequestID, oneClickRequestID, oneClickRequestDetailsIDList } = props;

  const [activeTab, setActiveTab] = useState(props.activeTab || 1);

  const classes = useStyles();

  return (
    <div className="tool-card">
      <div className={`tool-card-head`}>
        <ul>
          <li id="case-status-tab" className={`${classes.toolHeader} ${activeTab === 1 ? classes.active : ''}`} onClick={() => setActiveTab(1)}>CASE STATUS</li>
          {/*   In future, it might be useful
           <li className={`${classes.toolHeader} ${activeTab === 2 ? classes.active : ''}`} onClick={() => setActiveTab(2)}>REQUIREMENTS</li> */}
          {isIllustration && (<li id="documents-tab" className={`${classes.toolHeader} ${activeTab === 2 ? classes.active : ''}`} onClick={() => setActiveTab(2)}>DOCUMENTS</li>)} 
          <li id="ticket-tab" className={`${classes.toolHeader} ${activeTab === 3 ? classes.active : ''}`} onClick={() => setActiveTab(3)}>TICKET</li>
          <li id="additional-ticket-tab" className={`${classes.toolHeader} ${activeTab === 4 ? classes.active : ''}`} onClick={() => setActiveTab(4)}>ADDITIONAL TICKET INFO</li>
        </ul>
      </div>
      <div className="tool-card-content">
        {activeTab === 1 ? <CaseDetailStatus selectedCaseDetails={selectedCaseDetails} status={status} nextStep={nextStep} statusDetail={statusDetail} statuses={statuses} /> : ''}
        {/*   In future, it might be useful
        {activeTab === 2 ? <Requirements callGetCaseDetails={(tabNumber) => callGetCaseDetails(tabNumber)} caseRequirements={selectedCaseDetails} caseSummaryHistories={caseSummaryHistories} /> : ''} */}
        {activeTab === 2 && isIllustration ? <CaseDetailsFiles morganStanleyQuoteIllustrationRequestID={morganStanleyQuoteIllustrationRequestID} oneClickRequestID={oneClickRequestID} oneClickRequestDetailsIDList={oneClickRequestDetailsIDList} callGetCaseDetails={(tabNumber) => callGetCaseDetails(tabNumber)} caseImages={caseImages} requestDetails={requestDetails} selectedCaseDetails={selectedCaseDetails} isIllustration={isIllustration} permission={permission} referenceID ={referenceID}/> : ''} 
        {activeTab === 3 ? <Ticket caseImages={caseImages} requestDetails={requestDetails} selectedCaseDetails={selectedCaseDetails} typeId={typeId} /> : ''}
        {activeTab === 4 ? <AdditionalTicketInfo selectedCaseDetails={selectedCaseDetails} /> : ''}
      </div>
    </div>
  )
}

function CaseDetailStatus(props) {
  const { status, nextStep, statusDetail, statuses, selectedCaseDetails } = props;

  let statusObj = configureStatusObject(statuses, status);

  let activeStatusName = statuses.find(item => item.isActive === true);

  const [expanded, setExpanded] = React.useState(activeStatusName && activeStatusName.name);

  const handleClick = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const statusItems = statusObj.map((v, i) => <CaseDetailStatusCard
    key={i}
    name={v.name}
    iconSrc={v.iconSrc}
    isInProgress={v.name === status}
    isComplete={v.isComplete}
    isDisabled={v.isDisabled}
    statusDetail={statusDetail}
    expanded={expanded}
    handleClick={handleClick}
    nextStep={nextStep}
    caseDetails={selectedCaseDetails}
    status={status}
  />);

  return (
    <React.Fragment>
      {statusItems}
    </React.Fragment>
  )
}

function CaseDetailStatusCard(props) {

  const { iconSrc, name, isComplete, isDisabled, isInProgress, statusDetail, expanded, handleClick, nextStep, caseDetails, status } = props;
  let statusUpdateDate=null;
  const classes = useStyles();
  if(caseDetails){
    const statusHistory = caseDetails.caseSummaryHistories && caseDetails.caseSummaryHistories.find(x=>x.updatedStatus === name);
    if(statusHistory)
      statusUpdateDate = statusHistory.updatedStatusDateUTC;
  }
  return (
    <React.Fragment>
      <Accordion disabled={status ? isDisabled : true} expanded={expanded === name} onChange={handleClick(name)} classes={{ root: classes.MuiAccordionroot }} className={`status-item ${isInProgress ? 'in-progress' : ''} ${expanded !== name ? 'ml-4 mr-4' : 'expanded-accordion'}`} >
        <AccordionSummary aria-controls={`${name}-content`} id={`${name}-header`} className="status-item-summary">
          <Row className='w-100'>
            <Col sm={7}>
              <SvgIcon id={`${name}-icon`} component={iconSrc} alt={name + " Icon"} viewBox="0 0 30 30" />
              {expanded === name ?
                <SvgIcon id="arrow-dropdown-icon" component={ArrowDropDownIcon} alt={name + " DropDownIcon"} viewBox="0 0 30 30" /> :
                <SvgIcon id="arrow-right-icon" component={ArrowRightIcon} alt={name + " RightIcon"} viewBox="0 0 30 30" />
              }
              <span id={`${name}-header`} className='name-font'>{name}</span>
              {name === "Completing Application" && expanded === "Completing Application" && <SvgIcon id="warning-icon" viewBox="0 0 30 30" className="warn-icon ml-3" component={WarningGroup} />}
            </Col>
            <Col id='status-update-date' sm={3} className='item-state p-0'>
              {!isDisabled && statusUpdateDate !== null ? name === "Quoting Coverage" && expanded === "Quoting Coverage" ? ConvertUTCToLocalDateTime(statusUpdateDate) : ConvertUTCToLocalDate(statusUpdateDate) : ''}
            </Col>
            <Col id="status-label" sm={2} className='item-state p-0 text-right'>
              {isInProgress ? 'IN PROGRESS' : ''}
              {isComplete ? 'COMPLETE' : ''}
            </Col>
          </Row>
        </AccordionSummary>
        <AccordionDetails className="status-item-details">
          {isInProgress ? (
            <React.Fragment>
              <Row>
                <Col sm={7}>
                  <span id="name-status-details" className="status-details">{name} - {statusDetail}</span>
                </Col>
                <Col id="status-update-date-text" sm={3} className='item-date p-0'>
                  {!isDisabled && statusUpdateDate !== null? name === "Quoting Coverage" && expanded === "Quoting Coverage" ? ConvertUTCToLocalDateTime(statusUpdateDate) : ConvertUTCToLocalDate(statusUpdateDate) : ''}
                </Col>
                <Col sm={2}>
                  <SvgIcon id="loading-icon" viewBox="0 0 16 16" className="mr-1 float-right" component={LoadingWaiting} />
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <span id="next-step-text" className='next-step'>{nextStep}</span>
                </Col>
              </Row>
            </React.Fragment>) : <span id="application-complete-text" className="status-details">Application step complete</span>}
        </AccordionDetails>
      </Accordion>
    </React.Fragment>
  )
}

function Requirements(props) {
  const { caseRequirements, caseSummaryHistories, callGetCaseDetails } = props;
  let caseSummaryNotes = [];

  caseRequirements.caseNotes && caseRequirements.caseNotes.map((index) => {
    let noteObj = {
      updatedNoteDescription: index.note,
      noteOwner: index.createdAgentName || index.updatedName || index.createdName,
      updatedNoteDate: format(zonedTimeToUtc(index.lastModifiedDate, constants.serverIANATimezoneString), 'MM/dd/yyyy hh:mm aa'),
    }
    caseSummaryNotes.push(noteObj)
  })

  const { saveNoteSuccess, saveNoteFailure } = constants.NoteMessages;
  const [isNoteDialogOpen, setIsNoteDialogOpen] = useState(false);
  const [showAlertMessage, setshowAlertMessage] = useState(false);
  const [alertmessageSeverity, setalertmessageSeverity] = useState(false);
  const [alertMessage, setalertMessage] = useState(false);
  const [isSnackbarOpen, setisSnackbarOpen] = useState(true);
  const [loading, setLoading] = useState(false)

  const handleSaveNoteSuccess = () => {
    setIsNoteDialogOpen(false);

    setalertmessageSeverity('success');
    setalertMessage(saveNoteSuccess);
    setshowAlertMessage(true);
    setLoading(true)
    //API call for supervisory history
    callGetCaseDetails(2);
  };
  const handleSaveNoteFailure = () => {
    setIsNoteDialogOpen(false);

    setalertmessageSeverity('error');
    setalertMessage(saveNoteFailure);
    setshowAlertMessage(true);
  };
  return (
    <div>
      {loading ? (
        <Row className="d-flex justify-content-center">
          <CircularProgress className="mt-5 mb-5" />
        </Row>
      ) :

        <div>
          {showAlertMessage ?
            <Snackbar open={isSnackbarOpen} autoHideDuration={6000} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} onClose={() => setisSnackbarOpen(false)}>
              <Alert className="mt-4 mb-4" severity={alertmessageSeverity}>
                {alertMessage}
              </Alert>
            </Snackbar>
            : null}
          <React.Fragment>
            <div>
              <h5>Product Requirements</h5>
              {caseRequirements.hasRequirement ? <RequirementTable caseRequirements={caseRequirements.requirementsList} /> : <div> No requirments</div>}
              {
                (caseRequirements.caseID != null || caseRequirements.conciergeCaseID != null) &&
                <React.Fragment>
                  <Row className="mt-4 mb-8">
                    <Col sm={8}>
                      <h5>Case Notes</h5>
                    </Col>
                    <Col sm={4}>
                      <Button
                        className="d-flex mr-2 float-right"
                        startIcon={<SvgIcon component={NoteIcon} alt="NoteIcon" viewBox="0 0 24 24" fontSize="large" />}
                        variant="text"
                        size="medium"
                        type="button"
                        color="primary"
                        component="span"
                        onClick={() => setIsNoteDialogOpen(true)}
                      >
                        NOTE
                      </Button>
                      <Note
                        show={isNoteDialogOpen}
                        onHide={() => setIsNoteDialogOpen(false)}
                        details={caseRequirements}
                        onSaveNoteSuccess={handleSaveNoteSuccess}
                        onSaveNoteFailure={handleSaveNoteFailure}
                      />
                    </Col>
                  </Row>
                  <CaseDetailsNotes caseSummaryNotes={caseSummaryNotes} />
                </React.Fragment>
              }
              {(caseRequirements.caseID || caseRequirements.conciergeCaseID || (caseSummaryHistories && caseSummaryHistories.length > 0)) &&
                <Row className="mt-4 mb-9">
                  <Col sm={12}>
                    <h5>Case History</h5>
                    <div className="ml-2 pt-4"><CaseDetailsHistory caseSummaryHistories={caseSummaryHistories} /></div>
                  </Col>
                </Row>
              }
            </div>
          </React.Fragment>
        </div>
      }
    </div>

  );
}

function CaseDetailsNotes(props) {
  const { caseSummaryNotes } = props;
  return caseSummaryNotes.map((v, i) => (
    <CaseDetailsNoteCard updatedNoteDescription={v.updatedNoteDescription} noteOwner={v.noteOwner} updatedNoteDate={v.updatedNoteDate} updatedNoteTime={v.updatedNoteTime} key={i} />
  ));
}

function CaseDetailsNoteCard(props) {
  const { updatedNoteDescription, noteOwner, updatedNoteDate, updatedNoteTime } = props;

  return (
    <Row className="tool-card custom-Notes-Card">
      <Col sm={10}>
        <div className="custom-Notes-card-content">{updatedNoteDescription}</div>
        <div className="custom-Notes-card-font">
          {noteOwner} {updatedNoteDate}
        </div>
      </Col>
      <Col sm={2}>
        <SvgIcon className="float-right" alt="MenuIcon" viewBox="0 0 24 24" component={MenuIcon} />
      </Col>
    </Row>
  );
}

function CaseDetailsHistory(props) {
  const { caseSummaryHistories } = props;

  if (!caseSummaryHistories || caseSummaryHistories.length === 0) {
    return <div className="d-flex justify-content-center p-5"><p>Case history will show up here.</p></div>
  }

  const cards = caseSummaryHistories.map((v, i) => <CaseDetailsHistoryCard
    updatedStatus={v.updatedStatus}
    updatedStatusDescription={v.updatedStatusDescription}
    updatedStatusDate={v.updatedStatusDate}
    updatedStatusDateTimeDifference={v.updatedStatusDateTimeDifference}
    key={i}
  />)

  return cards;
}

function CaseDetailsHistoryCard(props) {

  const { updatedStatus, updatedStatusDescription, updatedStatusDate, updatedStatusDateTimeDifference } = props;

  const updatedStatusUtc = zonedTimeToUtc(updatedStatusDate, constants.serverIANATimezoneString);
  const updatedStatusFormattedTime = format(updatedStatusUtc, 'hh:mm aa');
  const updatedStatusFormattedDate = format(updatedStatusUtc, 'MMM dd, yyyy');

  return (
    <div className="history-card vertical-step mb-3">
      <div className="bullet">
        <RadioButtonUncheckedOutlinedIcon color="primary" fontSize="small" viewBox="0 0 30 30" />
      </div>
      <div className="content">
        <span id="status-time">{updatedStatusFormattedTime}, {updatedStatusFormattedDate} - {updatedStatusDateTimeDifference}</span><br />
        <span id="status-name">{updatedStatus}</span><br />
        <span id="status-description" dangerouslySetInnerHTML={{ __html: updatedStatusDescription }}></span>
      </div>
    </div>
  )
}

function CaseDetailsFiles(props) {
  const classes = useStyles();
  const history = useHistory();

  const { referenceID, callGetCaseDetails, caseImages, carrierName, caseId, isIllustration, requestDetails, permission, morganStanleyQuoteIllustrationRequestID, oneClickRequestID, oneClickRequestDetailsIDList } = props;

  let oneClickRequestDetailsID = oneClickRequestDetailsIDList.length > 0 ? Math.max.apply(Math, oneClickRequestDetailsIDList) : null;
  let arrayOfFiles = [];
  if (caseImages && caseImages.length > 0) {
      arrayOfFiles = caseImages;
    }
  
  const [documentType, setDocumentType] = useState('All');
  const [uploadAs, setUploadAs] = useState(2);
  const [filteredImagesList, setFilteredImagesList] = useState(arrayOfFiles);
  const [imagesList, setImagesList] = useState(arrayOfFiles);
  const [uploading, setUploading] = useState(false);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [fileData, setFileData] = useState([]);
  const [show, setShow] = useState(false);
  const [error, setError] = useState('');

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // if request was submited then status id should have 6
  const isRequestSubmitted = props.selectedCaseDetails && props.selectedCaseDetails.caseStatusID === 6;

  const getDocumentTypesOptions = () => {
    return [
      { value: 'All', label: 'All Document Types' },
      { value: 'Illustration', label: 'Illustrations' },
      { value: 'Application', label: 'Applications' },
      { value: 'Institution Form', label: 'Institutions Forms' },
      { value: 'Policy Contract', label: 'Policy Contracts' },
      { value: 'Other', label: 'Other' },
    ];
  };

  const getFilteredImages = () => {
    if (imagesList.length > 0) {
      if (documentType === "All") {
        setFilteredImagesList(imagesList);
      } else {
        const filteredList = imagesList.filter((image) => image.imageType === documentType);
        setFilteredImagesList(filteredList);
      }
    }
    setUploading(false);
  };

  useEffect(() => {
    getFilteredImages();
  }, [documentType, imagesList])

  let baseAddress = process.env.REACT_APP_COVR_SERVICES_URL;

  const submitFiles = () => {
    handleClose();
    if (filesToUpload && filesToUpload.length > 0) {
      setUploading(true);
      let url;
      let filesData;
      let fileInfo = [];
      const filesList = filesToUpload;
      const filesDataList = fileData;
      const isOneClickRequest = oneClickRequestID ? true : false;
      filesList.forEach((file, i) => {
        var attribute;
        if(file.carrierName === null)
        {
          attribute=[]
        }
        else{
          attribute=[{ name: 'CarrierName', stringValue: file.carrierName }]
        }
        let dataToPush = {
          entityID: isIllustration ? isOneClickRequest ? oneClickRequestDetailsID : morganStanleyQuoteIllustrationRequestID : null,
          referenceID : referenceID,
          productType: '',
          imageTypeID: file.imageTypeID,
          fileName: file.fileName,
          data: filesDataList[i],
          autoExpireDate: new Date(),
          attributes: attribute,
        }
        fileInfo.push(dataToPush);
      })

      filesData =  { isIllustration: isIllustration, oneClickRequestID: oneClickRequestID, morganStanleyFileInfoList: fileInfo },
    
   
      url = `${baseAddress}/api/MorganStanley/UploadImages`;

      httpRequest.post(url, filesData).then((data) => {
        if(data.success){
          setFileData([]);
          setFilesToUpload([]);
          callGetCaseDetails(2);
        }
        else{
          setError(data.messages);
        }
        }).catch((error) => {
        setUploading(false);
      });
    }
  }

  const columns = [
    {
      name: 'Name',
      cell: row => <div className={`${classes.colorPrimary} ${classes.pointer}`}><span onClick={() => DownloadFile(row)}>{row.imageName}</span></div>,
      selector: row => row.imageName,
      sortable: true
    },
    {
      name: 'Type',
      cell: row => <div className="rowType">{row.imageType}</div>,
      selector: row => row.imageType,
      sortable: true,
      maxWidth: '30%'
    },
    {
      name: 'Carrier',
      cell: row => <div className="rowType">{row.carrierName}</div>,
      selector: carrierName,
      sortable: true,
      maxWidth: '270px'
    },
    {
      name: 'Date Created',
      cell: (row) => <div className="rowType">{ConvertUTCToLocalDateTime(row.createdDate)}</div>,
      selector: row => row.dateCreated || row.createdDate,
      sortable: true,
      maxWidth: '300px'
    },
    {
      name: '',
      cell: row => isIllustration ?
       <div className={`${classes.colorPrimary} ${classes.pointer}`}><Button size="small" variant="text" color="primary" onClick={() => setSessionForIllustration(row)}>BEGIN APPLICATION</Button></div>
      : null
      ,
      minWidth: '150px'
    }
   ]

  if (permission === accessPermission.viewPermission) {
    columns.pop();
  }

  const setSessionForIllustration = (row) => {
    const dataForPrefill = {};
    const selectedCase = props.selectedCaseDetails;
    selectedCase.imageDetails = row;
    selectedCase.imageDetails.imageName = `${referenceID}_${props.selectedCaseDetails.imageDetails.imageType}.${props.selectedCaseDetails.imageDetails.imageExtension}`
    selectedCase.imageDetails.imageExtension = getExtension(props.selectedCaseDetails.imageDetails.imageExtension);
    selectedCase.illustrationType = referenceID.split('-')[0];
    dataForPrefill.selectedCaseDetails = selectedCase;
    let productType ={
      submitCaseProductKey : referenceID.split('-')[0]
    } 
    setSessionStorageItem(SESSION_STORAGE_CASE_RETURN_PATH,`/ActivityCenter/${referenceID}`)
    setSessionStorageItem(SELECTED_PRODUCT_FOR_SUBMIT_A_CASE,productType); 
    sessionStorage.removeItem(SESSION_STORAGE_CREATE_CASE);
    setSessionStorageItem(ILLUSTRATION_PREFILL_DATA, dataForPrefill);
    history.push(`/Activity/NewCase/Client`);
  };

  const customStyles = {
    table: {
      style: {
        overflowX: "hidden"
      }
    }
  }

  const getExtension = (extension) => {
    let type;

    switch(extension){
      case 'docx':
        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      case 'doc' : 
        return 'application/msword'
      case 'txt' :
        return 'text/plain'
      case 'pdf' :
        return 'application/pdf';
      case 'tif' :
      case 'tiff' :
      case 'mtiff' :
        return 'image/tiff';
      case 'png':
        return 'image/png'
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      default:
       return type;  
    }
  }

  const DownloadFile = (row) => {
    if (row.imageData) {
      let extension = row.imageExtension;
      let type = getExtension(extension);
      openFile(arrayBufferFromBase64(row.imageData), type)
      return
    }
    const queryParamsFile = new URLSearchParams({
      imageId: Number(row.externalImageID),
    });
    httpRequest.get(`${baseAddress}/api/Advisor/GetExternalImageFileData?${queryParamsFile.toString()}`)
      .then(data => {
        if (data) {
          let extension = row.imageExtension;
          let type = getExtension(extension);
          openFile(arrayBufferFromBase64(data.data), type,row.imageName)
        }
      })
  }

  return (
    <Container>
      <Row>
        <Col lg={5} className="text-left pl-0">
          <SelectInput
            name="documentType"
            id="documentType"
            value={documentType}
            onChange={(e) => setDocumentType(e.target.value)}
            label="Filter Document Type By"
            selectOptions={getDocumentTypesOptions()}
            hideEmptyOption
          />
        </Col>
        {/* <Col lg={7} className='pr-0 d-flex align-items-center justify-content-end'>
            <Button className='text-center' startIcon={<SvgIcon component={CloudUploadOutlinedIcon} />} disabled={uploadAs === ''} variant="text" size="small" type="button" color="primary" component="span" onClick={() => handleShow()} >UPLOAD</Button>
        </Col> */}
      </Row>

      <Row className="mt-2">
        <DataTable
          columns={columns}
          data={filteredImagesList}
          progressPending={uploading}
          progressComponent={<div className="d-flex justify-content-center p-5"><CircularProgress /></div>}
          persistTableHead
          customStyles={customStyles}
        />
      </Row>

      <UploadFileModal
        show={show}
        handleClose={handleClose}
        selectedCaseDetails={props.selectedCaseDetails}
        isIllustration={isIllustration}
        caseId={caseId}
        filesToUpload={filesToUpload}
        setFilesToUpload={setFilesToUpload}
        fileData={fileData}
        setFileData={setFileData}
        submitFiles={submitFiles}
        setError={error}
      />
    </Container>);
}



// WEBPACK FOOTER //
// ./src/components/ActivityCenter/SubComponents/CaseDetailsTool.js